export default __webpack_public_path__ + "static/media/2.bbf238c3.jpg";